module.exports = __webpack_public_path__ + "static/letsplay-b0c10b1182ec2cfabdd115bea9fb128b.png";